import React, { useState, useEffect, useRef } from "react";
import { IoMdSend, IoMdMore, IoMdArrowBack, IoMdSearch } from "react-icons/io";
import { Badge, Dropdown, FormControl } from "react-bootstrap";
import PrimarySidebar from "../PrimarySidebar/PrimarySidebar";

const chatMembers = [
  { id: 1, name: "Apple", img: "https://www.apple.com/ac/structured-data/images/knowledge_graph_logo.png", lastMessage: "Hello, we need info.", timestamp: "10:30 AM" },
  { id: 2, name: "Google", img: "https://png.pngtree.com/png-vector/20230817/ourmid/pngtree-google-internet-icon-vector-png-image_9183287.png", lastMessage: "Meeting at 2PM?", timestamp: "9:15 AM" },
  { id: 3, name: "Microsoft", img: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg", lastMessage: "Let's connect soon.", timestamp: "Yesterday" },
  { id: 4, name: "Amazon", img: "https://cdn0.iconfinder.com/data/icons/most-usable-logos/120/Amazon-512.png", lastMessage: "Great Work!", timestamp: "Monday" },
  { id: 5, name: "Tesla", img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Tesla_logo.png/1200px-Tesla_logo.png", lastMessage: "Schedule Call", timestamp: "Sunday" },
  { id: 6, name: "Facebook", img: "https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg", lastMessage: "Let's connect soon.", timestamp: "Saturday" },
  { id: 7, name: "Netflix", img: "https://i.pinimg.com/474x/e9/01/89/e901890458f1f47c2ca119394636c156.jpg", lastMessage: "New model update.", timestamp: "Friday" },
  { id: 8, name: "Twitter", img: "https://freepnglogo.com/images/all_img/1707222563twitter-logo-png.png", lastMessage: "New model update.", timestamp: "Thursday" },
];

const Messages = () => {
  const [selectedChat, setSelectedChat] = useState(chatMembers[0]);
  const [messages, setMessages] = useState([
    { sender: "Apple Inc", text: "Hello JBL Technologies, we need few information.", timestamp: new Date() },
    { sender: "You", text: "Yeah sure we will", timestamp: new Date() },
  ]);
  const [newMessage, setNewMessage] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const messagesEndRef = useRef(null);

  const filteredChats = chatMembers.filter((chat) =>
    chat.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSend = () => {
    if (newMessage.trim()) {
      setMessages([...messages, { sender: "You", text: newMessage, timestamp: new Date() }]);
      setNewMessage("");
    }
  };

  const handleBack = () => {
    setSelectedChat(null);
  };

  return (
    <>
      <PrimarySidebar />
      <div className="js-pg-hg mt-5 container cp-container">
        <div className="d-flex justify-content-between mb-4">
          <div className="heading pb-1">
            <h4>Messages</h4>
          </div>
          <Badge className="fs-6 p-2 px-2 small bg-white text-primary border border-primary d-flex align-items-center gap-2">
            <i className="bx bx-message fs-4"></i> Unread Messages
            <span className="d-flex justify-content-center align-items-center rounded-circle bg-primary text-light"
              style={{ width: "30px", height: "30px", borderWidth: "2px" }}>
              5
            </span>
          </Badge>
        </div>

        <div className="row g-0">
          <div className="col-lg-12 col-md-9 col-12">
            <div className="card border-0 shadow-sm" style={{ height: "75vh" }}>
              <div className="row g-0 h-100">
                {/* Conversations List */}
                <div className={`col-md-4 border-end ${selectedChat ? "d-none d-md-block" : "d-block"}`}>
                  <div className="p-3 bg-light border-bottom">
                    <h5 className="mb-0 fw-500">Conversations</h5>
                  </div>
                  {/* Search Bar */}
                  <div className="p-2">
                    <div className="input-group">
                      <span className="input-group-text bg-white border-0">
                        <IoMdSearch size={20} />
                      </span>
                      <FormControl
                        type="text"
                        placeholder="Search conversations..."
                        className="border-0"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                  </div>
                  {/* Chat List */}
                  <ul className="list-group list-message list-group-flush p-0 m-0 overflow-auto" style={{ height: "calc(75vh - 120px)" }}>
                    {filteredChats.map((person) => (
                      <li role="button"
                        key={person.id}
                        className={`list-group-item cursor-pointer list-group-item-action border-0 border-bottom mx-0 py-3 my-0 d-flex justify-content-between align-items-center ${
                          selectedChat?.id === person.id ? "bg-skyblue" : "bg-white"
                        }`}
                        onClick={() => setSelectedChat(person)}
                      >
                        <div className="d-flex align-items-center">
                          <img
                            src={person.img}
                            alt={person.name}
                            className="rounded-circle me-3"
                            style={{ width: "45px", height: "45px" }}
                          />
                          <div>
                            <h6 className="mb-1 fw-600">{person.name}</h6>
                            <small className="text-muted">{person.lastMessage}</small>
                          </div>
                        </div>




                        <div className="text-end">
                        <small className="text-muted">{person.timestamp}</small>
                                                        {/* Dropdown Menu */}
                                                        <Dropdown>
                          <Dropdown.Toggle as="button" variant="light" className="btn btn-link p-0 border-0 shadow-none">
                            <IoMdMore size={24} />
                          </Dropdown.Toggle>

                          <Dropdown.Menu align="end">
                            <Dropdown.Item onClick={() => console.log("Archive", person.id)}>📂 Archive</Dropdown.Item>
                            <Dropdown.Item onClick={() => console.log("Mute", person.id)}>🔕 Mute</Dropdown.Item>
                            <Dropdown.Item onClick={() => console.log("Block", person.id)}>🚫 Block</Dropdown.Item>
                            <Dropdown.Item onClick={() => console.log("Pin", person.id)}>📌 Pinned</Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>

                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Chat Window */}
                {selectedChat && (
                  <div className="col-md-8 col-12 d-flex flex-column">
                    <div className="p-3 bg-light border-bottom d-flex align-items-center">
                      <button
                        className="btn btn-primary rounded-circle p-2 me-3 d-md-none"
                        onClick={handleBack}
                      >
                        <IoMdArrowBack size={24} />
                      </button>
                      <img src={selectedChat.img} alt={selectedChat.name} className="rounded-circle me-3" style={{ width: "45px", height: "45px" }} />
                      <div>
                        <h5 className="mb-1 fw-600">{selectedChat.name}</h5>
                        <small className="text-success">Online</small>
                      </div>
                    </div>

                    <div className="flex-grow-1 p-4 overflow-auto bg-light" style={{ maxHeight: "63vh", overflowY: "auto" }}>
                      {messages.map((msg, index) => (
                        <div key={index} className={`d-flex mb-3 ${msg.sender === "You" ? "justify-content-end" : "justify-content-start"}`}>
                          <div className={`p-3 rounded-3 shadow-sm ${msg.sender === "You" ? "bg-primary text-white" : "bg-white text-dark"}`} style={{ maxWidth: "75%" }}>
                            {msg.sender !== "You" && <small className="d-block fw-600 mb-1">{msg.sender}</small>}
                            <p className="mb-1">{msg.text}</p>
                            <small lassName={`d-flex mb-3 ${msg.sender === "You" ? "text-dark" : "text-dark"}`}>{msg.timestamp.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</small>
                          </div>
                        </div>
                      ))}
                      <div ref={messagesEndRef} />
                    </div>

                    <div className="p-3 bg-light border-top">
                      <div className="input-group">
                        <input type="text" className="form-control rounded-start-pill border-0 bg-white shadow-sm" placeholder="Type your message..." value={newMessage} onChange={(e) => setNewMessage(e.target.value)} />
                        <button className="btn btn-primary rounded-end-pill shadow-sm px-3" onClick={handleSend}>
                          <IoMdSend size={20} />
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Messages;